import type { NeverFunc } from "@suse-o11y/never-func";
import { unpurry } from "@suse-o11y/unpurry";
import { isStrictEqual as isStrictEqual_ } from "remeda";

export const isStrictEqual = unpurry(isStrictEqual_, 2) as typeof isStrictEqual_ & NeverFunc;
